import { render } from "./product-swatches.vue?vue&type=template&id=11669564"
import script from "./product-swatches.vue?vue&type=script&lang=js"
export * from "./product-swatches.vue?vue&type=script&lang=js"

import "./product-swatches.vue?vue&type=style&index=0&id=11669564&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__